"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BulkPrice = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _Tooltip = require("b2b-components/theme/components/Tooltip");
var _classnames = _interopRequireDefault(require("classnames"));
require("./BulkPrice.scss");
const BulkPrice = _ref => {
  let {
    bulkPrice,
    text,
    className
  } = _ref;
  if (!bulkPrice || !bulkPrice?.length) {
    return null;
  }
  const rootClassName = (0, _classnames.default)('cds-BulkPrice-Container', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: rootClassName
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    className: "cds-BulkPrice-Icon",
    name: _Icon.ICON_NAME.bulk,
    size: _Icon.ICON_SIZE.small
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    className: "cds-BulkPrice-Underline",
    content: bulkPrice.map((bulk, index) => index !== 0 && /*#__PURE__*/_react.default.createElement("div", {
      key: bulk.discountPercentage,
      className: (0, _classnames.default)('cds-BulkPrice', {
        'cds-BulkPrice--DisableBorder': index === bulkPrice.length - 1
      })
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-BulkPrice-BoldText"
    }, text.buy, " ", bulk.minQuantity), /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-BulkPrice-Price"
    }, "CHF ", /*#__PURE__*/_react.default.createElement("span", {
      className: "cds-BulkPrice-BoldText"
    }, bulk.priceWithoutVat.toFixed(2))), /*#__PURE__*/_react.default.createElement("div", {
      className: "cds-BulkPrice-Discount"
    }, bulk.discountPercentage * -1, "%")))
  }, text.bulkPricing));
};
exports.BulkPrice = BulkPrice;
//# sourceMappingURL=BulkPrice.js.map